module.exports = __webpack_public_path__ + "2928664fe1fc6aca88583a6f606d60ba.svg";


//////////////////
// WEBPACK FOOTER
// ./content/about/badges/ios_appstore.svg
// module id = 1303
// module chunks = 0